import { createAsyncThunk } from "@reduxjs/toolkit";
import { AXIOS_RESERVATION } from "../../../../utils/axiosInterceptors";
import { config } from "../../../../config";

export const fetchRoomTypes = createAsyncThunk(
  "roomTypes/getallroomtypesandroomplanes",
  async (state, { getState, rejectWithValue, dispatch }) => {
    // console.log("amenities payload:", state);

    try {
      let { data } = await AXIOS_RESERVATION.get(
        `getallroomtypesandroomplanes`
      );

      // console.log("data:", data);

      return data;
    } catch (err) {
      // console.log("err:", err);

      throw rejectWithValue({
        status: {
          apiSuccess: false,
          apiMessage:
            err?.result?.message ||
            "Something went wrong please try again later",
        },
      });
    }
  }
);

export const addRoomTypes = createAsyncThunk(
  "roomTypes/addroomtypes",
  async (state, { getState, rejectWithValue, dispatch }) => {
    console.log("roomTypes payload:", state);

    let { CB, ...others } = state;
    others.hotelId = config.HOTELID;

    console.log("others:", others);

    var headers = {
      "Access-Control-Allow-Origin": "*",
    };

    try {
      let { data } = await AXIOS_RESERVATION.post(`addroomtypes`, others, {
        headers,
      });
      // console.log("data:", data);

      if (data?.success == false) {
        CB && CB(data);
      } else {
        CB && CB(data);
        dispatch(fetchRoomTypes());

        return data;
      }
    } catch (err) {
      // console.log("err:", err);

      CB && CB(err);
      throw rejectWithValue({
        status: {
          apiSuccess: false,
          apiMessage:
            err?.result?.message ||
            "Something went wrong please try again later",
        },
      });
    }
  }
);

export const updateRoomTypes = createAsyncThunk(
  "roomTypes/updateRoomTypes",
  async (state, { getState, rejectWithValues, dispatch }) => {
    let { CB, ...others } = state;
    console.log("others", others);

    try {
      let { data } = await AXIOS_RESERVATION.post("updateRoomTypes", others);

      if (data?.success == false) {
        CB && CB(data);
      } else {
        CB && CB(data);
        dispatch(fetchRoomTypes());

        return data;
      }
    } catch (err) {
      throw rejectWithValues({
        status: {
          apiSuccess: false,
          apiMessage:
            err?.result?.message ||
            "Something went wrong please try again later",
        },
      });
    }
  }
);

export const removeRoomTypes = createAsyncThunk(
  "roomTypes/removeRoomTypes",
  async (state, { getState, rejectWithValue, dispatch }) => {
    let { id, CB } = state;
    console.log("_id:", id);

    var headers = {
      _id: id,
      "Access-Control-Allow-Origin": "*",
    };

    try {
      let { data } = await AXIOS_RESERVATION.delete("removeRoomTypes", {
        headers,
      });
      if (data?.success == false) {
        CB && CB(data);
      } else {
        CB && CB(data);
        dispatch(fetchRoomTypes());

        return data;
      }
    } catch (err) {
      throw rejectWithValue({
        status: {
          apiSuccess: false,
          apiMessage:
            err?.result?.message ||
            "Something went wrong please try again later",
        },
      });
    }
  }
);
